<template>
    <div
        class="details__component"
        v-if="showDetailsComponent"
        :class="$helpers.onlyVRMActive() ? 'd-none' : ''"
    >
        <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="200"
            :min-width="$vuetify.breakpoint.smAndUp ? 422 : ''"
            :max-width="$vuetify.breakpoint.smAndUp ? '' : 340"
            offset-x
        >
            <template v-slot:activator="{ on, attrs }">
                <div class="btn--detalhes" v-bind="attrs" v-on="on">
                    <div
                        @click="openInformations()"
                        class="content__buttom--detalhes"
                    >
                        <div class="content__text--detalhes">
                            {{ detailsTitle }}
                        </div>
                        <div class="icon--button">
                            <svg
                                style="width: 24px; height: 24px"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"
                                />
                            </svg>
                        </div>
                    </div>
                </div>
            </template>

            <v-card :class="$helpers.onlyVRMActive() ? 'd-none' : ''">
                <v-list>
                    <v-list-item>
                        <div class="box-list-informations">
                            <ul>
                                <li
                                    v-for="(item, index) in vehicleData"
                                    :key="index"
                                >
                                    <div class="box--list">
                                        <div
                                            :class="
                                                item.value == 'subtitle_class'
                                                    ? 'class-subtitle'
                                                    : 'subs-title'
                                            "
                                        >
                                            {{ item.name }}
                                        </div>
                                        <div
                                            v-if="
                                                item.name !==
                                                $t(
                                                    'details-component.mark-date'
                                                )
                                            "
                                            :class="
                                                $vuetify.breakpoint.xsOnly
                                                    ? 'breakword-class'
                                                    : ''
                                            "
                                            :style="
                                                item.value.length > 25
                                                    ? 'word-break: break-all; text-align: left; width: 220px'
                                                    : ''
                                            "
                                        >
                                            {{
                                                item.value == "subtitle_class"
                                                    ? ""
                                                    : item.value
                                            }}
                                        </div>
                                        <div
                                            v-if="
                                                item.name ==
                                                $t(
                                                    'details-component.mark-date'
                                                )
                                            "
                                            style="
                                                text-transform: lowercase !important;
                                            "
                                        >
                                            {{ item.value }}
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-menu>
    </div>
</template>

<script>
import mixinDetailsData from "@mixins/b2b/detailsData.js";

export default {
    mixins: [mixinDetailsData],
    data() {
        return {
            menu: false,
        };
    },
    watch: {
        computedVehicle: {
            handler: function (newValue) {
                if (!newValue) {
                    this.menu = false;
                }
            },
        },
    },
    computed: {
        computedVehicle() {
            return this.$store.getters["vehicleIdentification/getState"]
                .processNumber;
        },
    },
    methods: {
        openInformations() {
            if (this.$helpers.onlyVRMActive()) {
                this.menu = true;
                if (this.$route.name !== "vehicleIdentification") {
                    this.$router.push({ name: "vehicleIdentification" });
                }
            }
        },
    },
    mounted() {
        this.openInformations();
    },
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";

@keyframes animateShowHistory {
    0% {
        height: 0;
        opacity: 0;
    }
    100% {
        height: auto;
        opacity: 1;
    }
}

.details__component {
    .v-btn:before {
        background: none !important;
    }

    .btn--detalhes {
        border: none;
        outline: none !important;
        margin: 6px 15px;

        .content__buttom--detalhes {
            padding: 1px 5px 1px 14px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: var(--v-primary-base);
            background-color: $grey-light;
            border-radius: 5px;
            font-family: Lato;

            .content__text--detalhes {
                font-size: 0.85em;
                font-weight: normal;
                padding: 5px 0;
                text-transform: uppercase;
                color: var(--v-primary-base);
            }

            .icon--button {
                display: flex;
                align-items: center;

                svg {
                    fill: var(--v-primary-base);
                }
            }
        }
    }
}

.box-list-informations {
    width: 100%;

    ul {
        width: 100%;
        list-style: none;
        margin: 4px 0 0;
        padding: 0;

        li:nth-child(even) {
            background: $grey-light;
            padding: 2px 2px 2px 0px;
        }

        li {
            margin: 2px 0;

            .box--list {
                display: flex;

                @media (max-width: 426px) {
                    justify-content: space-between;
                }

                div {
                    font-family: Lato;
                    letter-spacing: 0.01em;
                    font-size: 14px;

                    &:first-child {
                        color: var(--v-primary-darken3);
                        white-space: nowrap;
                    }
                    &:last-child {
                        float: right;
                        color: var(--v-primary-base);
                        text-transform: uppercase;
                        font-size: 14px;
                        text-align: right;
                        margin-left: 5px;
                    }
                }
            }
        }
    }

    .class-subtitle {
        font-size: 16px !important;
        font-weight: bold;
    }

    .subs-title {
        width: 164px;
        @media (max-width: 426px) {
            /* width: 100%; */
        }
    }

    .breakword-class {
        text-align: right !important;
    }
}
</style>
